import { useEffect, useMemo } from "react";

import { useGetAllSeriesQuery } from "../../series-api";
import { useGetAllTeamsQuery } from "../../team-api";
import { useLazyGetSinglePlayQuery } from "../play-api";
import { convertPlayPayloadToSportPlay } from "../utils/convert-play-payload-to-sport-play";

export const useGetSinglePlay = (playId: string | undefined | null) => {
  const { data: teams, isSuccess: isTeamsLoaded } = useGetAllTeamsQuery();
  const { data: series, isSuccess: isSeriesLoaded } = useGetAllSeriesQuery();

  const [getSinglePlay, { data, ...restUseGetSinglePlayQueryResp }] = useLazyGetSinglePlayQuery();

  useEffect(() => {
    if (playId) getSinglePlay({ id: playId });
  }, [playId, getSinglePlay]);

  const convertedData = useMemo(
    () =>
      data && isTeamsLoaded && isSeriesLoaded
        ? convertPlayPayloadToSportPlay({ play: data, teams, series })
        : undefined,
    [data, isTeamsLoaded, isSeriesLoaded, teams, series]
  );

  return { data: convertedData, ...restUseGetSinglePlayQueryResp };
};
